import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { listsMappedProps } from 'app/shapes/browse/rows';
import Lists from './Lists';

const ListsContainer = ({
  additionalAnalyticsPayload,
  lists,
  title,
  trackListCreatorClick,
  trackListImageClick,
  trackListImpression,
  trackListTitleClick,
  userByListId
}) => {
  const library = useSelector(selectCurrentLibrary);

  return (
    <Lists
      additionalAnalyticsPayload={additionalAnalyticsPayload}
      lists={lists}
      library={library}
      title={title}
      trackListCreatorClick={trackListCreatorClick}
      trackListImageClick={trackListImageClick}
      trackListImpression={trackListImpression}
      trackListTitleClick={trackListTitleClick}
      userByListId={userByListId}
    />
  );
};

ListsContainer.defaultProps = {
  additionalAnalyticsPayload: {}
};

ListsContainer.propTypes = {
  ...listsMappedProps,
  additionalAnalyticsPayload: PropTypes.object,
  trackListCreatorClick: PropTypes.func.isRequired,
  trackListImageClick: PropTypes.func.isRequired,
  trackListImpression: PropTypes.func.isRequired,
  trackListTitleClick: PropTypes.func.isRequired
};

export default ListsContainer;
